import { createStyle } from '@gluestack-style/react';

export const BadgeIcon = createStyle({
  props: {
    size: 'md',
  },
});
